import { Pressable, StyleSheet, Text } from "react-native";
import { useTranslation } from "react-i18next";

import type { UiTheme } from "../theme";

// DS-67 — ⛔ UN interruttore per TUTTI i campi che governa, non uno per campo.
// Dove la password si sta inventando va ridigitata alla cieca, e due
// interruttori separati costringerebbero a due gesti per fare la sola cosa che
// serve: confrontare quello che si è scritto due volte.
//
// Estratto da WelcomeForm quando la fase di reset di ForgotPasswordScreen ha
// chiesto lo stesso gesto su UN campo solo — di qui `count`, che sceglie fra
// «Mostra la password» e «Mostra le password» invece di lasciare al plurale di
// WelcomeForm il compito di parlare anche per il singolare.
export type RevealPasswordToggleProps = {
  theme: UiTheme;
  revealed: boolean;
  onToggle: () => void;
  /** Quanti campi password governa. Decide singolare/plurale della scritta. */
  count: number;
};

export function RevealPasswordToggle({
  theme,
  revealed,
  onToggle,
  count,
}: RevealPasswordToggleProps) {
  const { t } = useTranslation();
  const styles = makeStyles(theme);

  return (
    <Pressable
      // ⛔ `button` e non `switch`, ed è una scelta fra due canali che si
      // doppiavano: con `switch` lo stato lo dice `checked`, e l'etichetta deve
      // restare ferma — ma qui non c'è nessun interruttore DISEGNATO, quindi
      // per chi guarda l'unico segnale di stato è il testo che cambia. Tenere
      // il testo dinamico e scendere a `button` è la forma dei toggle «occhio»
      // di Chrome e dei gestori di password. Alzato dall'audit a11y.
      accessibilityRole="button"
      hitSlop={12}
      onPress={onToggle}
      style={styles.revealHit}
    >
      <Text style={styles.reveal}>
        {revealed
          ? t("auth.hidePassword", { count })
          : t("auth.revealPassword", { count })}
      </Text>
    </Pressable>
  );
}

function makeStyles(theme: UiTheme) {
  const { palette: p, typography: ty } = theme;
  return StyleSheet.create({
    revealHit: { minHeight: 44, justifyContent: "center" },
    reveal: {
      color: p.brand500,
      fontSize: ty.sizes.base,
      fontWeight: "600",
    },
  });
}
